import { cn } from "@/lib/utils/cn";
import { Button } from "@/ui-components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/ui-components/ui/select";
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from "lucide-react";

export interface DataTable2PaginationProps {
  currentPage: number;
  pageCount: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
  onPageChange: (page: number) => void;
  className?: string;
  pageSize?: number;
  pageSizeOptions?: number[];
  onPageSizeChange?: (pageSize: number) => void;
}

export function DataTable2Pagination({
  currentPage,
  pageCount,
  hasNextPage,
  hasPrevPage,
  onPageChange,
  className,
  pageSize,
  pageSizeOptions = [10, 20],
  onPageSizeChange,
}: DataTable2PaginationProps) {
  if (pageCount <= 1) return null;

  return (
    <div className={cn("flex flex-col gap-3 md:flex-row md:items-center md:justify-between", className)}>
      <div className="flex items-center gap-3 text-sm text-gray-500">
        {typeof pageSize === "number" && onPageSizeChange ? (
          <div className="flex items-center gap-2">
            <span className="hidden sm:inline">Zeilen pro Seite</span>
            <Select value={String(pageSize)} onValueChange={(v) => onPageSizeChange(Number(v))}>
              <SelectTrigger className="h-9 w-[84px] rounded-xl bg-white">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {pageSizeOptions.map((opt) => (
                  <SelectItem key={opt} value={String(opt)}>
                    {opt}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        ) : null}
        <span>
          Seite {currentPage} von {pageCount}
        </span>
      </div>

      <div className="flex items-center justify-end gap-1.5">
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={() => onPageChange(1)}
          disabled={!hasPrevPage}
          className="h-9 w-9 p-0 rounded-xl bg-white border-gray-200 hover:bg-gray-50"
        >
          <ChevronsLeft className="h-4 w-4" />
        </Button>
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={!hasPrevPage}
          className="h-9 w-9 p-0 rounded-xl bg-white border-gray-200 hover:bg-gray-50"
        >
          <ChevronLeft className="h-4 w-4" />
        </Button>

        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={!hasNextPage}
          className="h-9 w-9 p-0 rounded-xl bg-white border-gray-200 hover:bg-gray-50"
        >
          <ChevronRight className="h-4 w-4" />
        </Button>
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={() => onPageChange(pageCount)}
          disabled={!hasNextPage}
          className="h-9 w-9 p-0 rounded-xl bg-white border-gray-200 hover:bg-gray-50"
        >
          <ChevronsRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
